export default __webpack_public_path__ + "static/media/Roboto-Light.4ca61622.woff2";